import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Loader2, AlertTriangle } from 'lucide-react';

interface BulkDuplicateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  onConfirm: () => void;
  isDuplicating: boolean;
  remainingCredits?: number;
}

export function BulkDuplicateDialog({
  open,
  onOpenChange,
  count,
  onConfirm,
  isDuplicating,
  remainingCredits,
}: BulkDuplicateDialogProps) {
  const itemType = count === 1 ? 'orçamento' : 'orçamentos';
  const creditWord = count === 1 ? 'crédito' : 'créditos';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Duplicar {count} {itemType}?
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Essa ação irá consumir <strong>{count} {creditWord}</strong> da sua conta.
            </p>
            {remainingCredits !== undefined && (
              <p className="text-sm text-muted-foreground">
                Você possui {remainingCredits} crédito{remainingCredits !== 1 ? 's' : ''} restante{remainingCredits !== 1 ? 's' : ''} neste mês. A cota renova todo dia 1º.
              </p>
            )}
            <p>Deseja continuar?</p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDuplicating}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDuplicating}
          >
            {isDuplicating ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Duplicando...
              </>
            ) : (
              'Duplicar'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
